import { api } from '@/api';

/**
 * Request body for `admin-utils/add-organisation`. Mirrors the backend's
 * snake_case contract exactly (see the Global-admin endpoint guide) — the
 * caller passes these through unchanged so a global admin can self-serve a
 * new organisation.
 */
export interface AddOrganisationProps {
  name: string;
  nameDisplayable: string;
  emailDomains: string[];
  retentionInWeeksPostCaseClosure: number;
  retentionInWeeksPostFirstRecordUpload: number;
  storageContainer: string;
}

export interface AddOrganisationResponse {
  organisationId: string;
}

const addOrganisationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postAddOrganisation: builder.query<AddOrganisationResponse, AddOrganisationProps>({
      query: (props: AddOrganisationProps) => ({
        url: `admin-utils/add-organisation`,
        method: 'POST',
        body: {
          name: props.name,
          name_displayable: props.nameDisplayable,
          email_domains: props.emailDomains,
          retention_in_weeks_post_case_closure: props.retentionInWeeksPostCaseClosure,
          retention_in_weeks_post_first_record_upload: props.retentionInWeeksPostFirstRecordUpload,
          storage_container: props.storageContainer,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostAddOrganisationQuery } = addOrganisationApi;
